export function buildAcceleratorRegistrationPayload(form, inviteCode) {
    return {
        full_name: form.full_name,
        email: String(form.email || '').trim().toLowerCase(),
        institution: form.company_name,
        invite_code: inviteCode,
        password: form.password,
        passwordConfirmation: form.cpassword,
    };
}
